var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1012",
    "data-name": "Group 1012",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash-alt",
    d: "M9.222,16.4a.894.894,0,0,0,.889-.9V10.1a.889.889,0,1,0-1.778,0v5.4A.894.894,0,0,0,9.222,16.4ZM18.111,5.6H14.556V4.7A2.683,2.683,0,0,0,11.889,2H10.111A2.683,2.683,0,0,0,7.444,4.7v.9H3.889a.9.9,0,0,0,0,1.8h.889v9.9A2.683,2.683,0,0,0,7.444,20h7.111a2.683,2.683,0,0,0,2.667-2.7V7.4h.889a.9.9,0,0,0,0-1.8ZM9.222,4.7a.894.894,0,0,1,.889-.9h1.778a.894.894,0,0,1,.889.9v.9H9.222Zm6.222,12.6a.894.894,0,0,1-.889.9H7.444a.894.894,0,0,1-.889-.9V7.4h8.889Zm-2.667-.9a.894.894,0,0,0,.889-.9V10.1a.889.889,0,1,0-1.778,0v5.4A.894.894,0,0,0,12.778,16.4Z",
    transform: "translate(-3 -2)",
    fill: "#f5222d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d925d8bccbc900584bd4cee3ae5f9110.svg";
export { ForwardRef as ReactComponent };